const aboutPage = {
  "about.terms-of-use.title": "Terms of Use",
  "about.terms-of-use.description": "By using Be Your Best, you agree to our Terms of Use.",
  "about.privacy.title": "Privacy",
  "about.privacy.description": "By using Be Your Best, you agree to our Privacy Policy.",
  "about.app-version": "App Version",
};

export const about = {
  ...aboutPage,
};